var _circle, _circle2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMedal = function SvgMedal(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "url(#a)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 120,
    height: 120,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#6B0707"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9B0B17",
    d: "m48 43.62 27.713 16-24.5 42.436c-1.648 2.854-5.848 2.602-7.143-.429C31.27 71.66 24.257 84.744 48 43.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9B0B17",
    d: "M43.5 102.04h4v2h-4zM74 102.04h4v2h-4zM94.5 90.04h4.4v2h-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9B0B17",
    d: "m50 59.62 27.713-16 24.5 42.436c1.648 2.854-.67 6.365-3.943 5.97l-11.914-1.434-4.713 11.035c-1.295 3.031-5.495 3.283-7.143.429L50 59.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9B0B17",
    stroke: "#F87C86",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m21.232 87.056 23.5-40.704 24.249 14-23.5 40.704c-.824 1.427-2.924 1.301-3.572-.215l-4.713-11.035a2 2 0 0 0-2.079-1.2L23.203 90.04c-1.636.197-2.795-1.558-1.97-2.985Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9B0B17",
    stroke: "#F87C86",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m72.232 101.056-23.5-40.704 24.249-14 23.5 40.704c.824 1.427-.335 3.182-1.971 2.985l-11.914-1.435a2 2 0 0 0-2.079 1.2l-4.714 11.035c-.647 1.516-2.747 1.642-3.57.215Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9B0B17",
    d: "M90 56c0 3.148-.52 6.175-1.478 9C82 54 77.816 55.5 65.5 55.5 50.036 55.5 34 71.464 34 56s12.536-28 28-28 28 12.536 28 28Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 52,
    r: 28,
    fill: "#F87C86"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 52,
    r: 24,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9B0B17",
    fillRule: "evenodd",
    d: "m59 62.095-7.541 3.923c-1.469.764-3.177-.485-2.894-2.116L50 55.624l-6.059-5.845c-1.197-1.155-.543-3.182 1.104-3.419l8.393-1.207 3.772-7.564c.737-1.477 2.843-1.477 3.58 0l3.772 7.564 8.393 1.207c1.647.237 2.301 2.264 1.104 3.42L68 55.623l1.435 8.278c.282 1.631-1.425 2.88-2.894 2.116L59 62.095Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 60,
    x2: 60,
    y1: 0,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.047,
    stopColor: "#FFC7D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBED9"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMedal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "medal.e375805a858b5755d85a93325e4eab60.svg";